<template>
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.9488 7.75002L10.998 1.89073L12.752 0.109314L21.7816 9.00002L12.752 17.8907L10.998 16.1093L16.9488 10.25H0V7.75002H16.9488Z"
      fill="white"
    />
  </svg>
</template>
